"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column'
    },
    groupLabel: {
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(30),
      color: theme.palette.NEUTRAL800,
      marginBottom: theme.spacing(2)
    },
    description: {
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
      color: theme.palette.NEUTRAL300,
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0)
    },
    items: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        marginBottom: theme.spacing(2),
        marginRight: theme.spacing(3)
      }
    },
    vertical: {
      flexDirection: 'column',
      '& > *': {
        marginRight: theme.spacing(0),
        marginBottom: theme.spacing(0)
      },
      '& + $description': {
        marginTop: theme.spacing(2)
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;